import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Button, Dialog, DialogContent, DialogTitle, Divider, Tooltip } from '@mui/material';
import { Box } from '@mui/system';

const ModalWrapper = ({
  open,
  onClose,
  onConfirm,
  title,
  children,
  isPending,
  disabled,
  isShowTooltip = true,
  maxWidth = 'md',
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth || 'md'} sx={{ p: 0 }}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
          fontWeight: 600,
          height: '56px',
        }}
      >
        <Box display={'flex'} alignItems={'center'} gap={0.4}>
          {title}
          {isShowTooltip && (
            <Tooltip
              arrow
              title={`${title === 'Update Tag' ? 'Update' : 'Create'}  tags and assign them to different transcripts and individuals of the interview.`}
            >
              <InfoOutlinedIcon sx={{ color: '#8C8C8C', fontSize: '20px' }} />
            </Tooltip>
          )}
        </Box>
        {title !== 'Assign Tag' || title !== 'Tag Library' ? (
          <Box display={'flex'} gap={1.5}>
            <Button variant="custom" sx={{ ml: 'auto', cursor: 'pointer' }} onClick={onClose}>
              Cancel
            </Button>
            <Button
              disabled={disabled || isPending}
              sx={{ ml: 'auto', cursor: 'pointer' }}
              onClick={onConfirm}
              variant="contained"
            >
              {isPending ? 'Saving' : 'Save'}
            </Button>
          </Box>
        ) : (
          <Box>
            <CloseIcon sx={{ ml: 'auto', cursor: 'pointer' }} onClick={onClose} />
          </Box>
        )}
      </DialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default ModalWrapper;
